import React from 'react'
import { Typography } from '@mui/material'
import { formatNumber } from '@auteco/utils/formatsNumber'
import { COLORS, getHeaderStyle, getSubHeaderStyle } from './styles'
import EditableNSCell from './components/EditableNSCell'
import NumberCell from './components/NumberCell'

export const createColumns = (handleNSEdit, handleRestore, editedRows) => [
  {
    header: 'Modelo Planeación',
    muiTableHeadCellProps: {
      sx: getHeaderStyle(COLORS.purple),
    },
    columns: [
      {
        accessorKey: 'modeloPlaneacion',
        header: 'Modelo Planeación',
        enableEditing: false,
        muiTableHeadCellProps: {
          sx: getSubHeaderStyle(COLORS.purpleLight),
        },
      },
      {
        accessorKey: 'planVentas',
        header: 'Plan de Ventas',
        enableEditing: false,
        muiTableHeadCellProps: {
          sx: getSubHeaderStyle(COLORS.purpleLight),
        },
        Cell: ({ cell }) => formatNumber(cell.getValue())
      },
    ],
  },
  {
    header: 'Demanda',
    muiTableHeadCellProps: {
      sx: getHeaderStyle(COLORS.blue),
    },
    columns: [
      {
        accessorKey: 'ventasPromedioDiarias',
        header: 'Ventas promedio diarias',
        enableEditing: false,
        muiTableHeadCellProps: {
          sx: getSubHeaderStyle(COLORS.blueLight),
        },
        Cell: ({ cell }) => formatNumber(cell.getValue())
      },
      {
        accessorKey: 'desviacionVentasDiaria',
        header: 'Desviación estándar de ventas DIARIA',
        enableEditing: false,
        muiTableHeadCellProps: {
          sx: getSubHeaderStyle(COLORS.blueLight),
        },
        Cell: ({ cell }) => formatNumber(cell.getValue())
      },
    ],
  },
  {
    header: 'Leadtime',
    muiTableHeadCellProps: {
      sx: getHeaderStyle(COLORS.green, 'black'),
    },
    columns: [
      {
        accessorKey: 'tiempoPromedioEntrega',
        header: 'Tiempo promedio de entregas (días)',
        enableEditing: false,
        muiTableHeadCellProps: {
          sx: getSubHeaderStyle(COLORS.greenLight),
        },
        Cell: ({ cell }) => formatNumber(cell.getValue())
      },
      {
        accessorKey: 'desviacionTiempoEntrega',
        header: 'Desviación estándar de tpo ent',
        enableEditing: false,
        muiTableHeadCellProps: {
          sx: getSubHeaderStyle(COLORS.greenLight),
        },
        Cell: ({ cell }) => formatNumber(cell.getValue())
      },
    ],
  },
  {
    accessorKey: 'desviacionCombinada',
    header: 'Desviación Combinada',
    enableEditing: false,
    muiTableHeadCellProps: {
      sx: getHeaderStyle(COLORS.purple),
    },
    Cell: ({ cell }) => formatNumber(cell.getValue())
  },
  {
    header: 'Optimizando costos',
    muiTableHeadCellProps: {
      sx: getHeaderStyle(COLORS.orange, 'black'),
    },
    columns: [
      {
        accessorKey: 'nsOptimo',
        header: 'NS óptimos',
        enableEditing: false,
        muiTableHeadCellProps: {
          sx: getSubHeaderStyle(COLORS.orangeLight),
        },
        Cell: ({ cell }) => (
          <NumberCell value={cell.getValue() * 100} suffix="%" />
        )
      },
      {
        accessorKey: 'diasInventarioOptimo',
        header: 'Días Inventario',
        enableEditing: false,
        muiTableHeadCellProps: {
          sx: getSubHeaderStyle(COLORS.orangeLight),
        },
        Cell: ({ cell }) => formatNumber(cell.getValue())
      },
      {
        accessorKey: 'costoOptimo',
        header: 'Suma de costos óptimo',
        enableEditing: false,
        muiTableHeadCellProps: {
          sx: getSubHeaderStyle(COLORS.orangeLight),
        },
        Cell: ({ cell }) => `$${formatNumber(cell.getValue())}`
      },
      {
        accessorKey: 'inventarioMedioOptimo',
        header: 'Inventario medio',
        enableEditing: false,
        muiTableHeadCellProps: {
          sx: getSubHeaderStyle(COLORS.orangeLight),
        },
        Cell: ({ cell }) => formatNumber(cell.getValue())
      },
    ],
  },
  {
    header: 'NS escogido',
    muiTableHeadCellProps: {
      sx: getHeaderStyle(COLORS.greenDark),
    },
    columns: [
      {
        accessorKey: 'nsEscogido',
        header: 'NS',
        muiTableHeadCellProps: {
          sx: getSubHeaderStyle(COLORS.greenDarkLight),
        },
        enableEditing: false,
        Cell: ({ cell, row }) => (
          <EditableNSCell
            cell={cell}
            row={row}
            onEdit={handleNSEdit}
            onRestore={handleRestore}
            isEdited={editedRows.has(row.original.modeloPlaneacion)}
          />
        ),
      },
      {
        accessorKey: 'diasInventarioEscogido',
        header: 'Días Inventario',
        enableEditing: false,
        muiTableHeadCellProps: {
          sx: getSubHeaderStyle(COLORS.greenDarkLight),
        },
        Cell: ({ cell, row }) => (
          <NumberCell 
            value={cell.getValue()} 
            decimals={1}
            isEdited={editedRows.has(row.original.modeloPlaneacion)}
          />
        ),
      },
      {
        accessorKey: 'costoEscogido',
        header: 'Suma de costos óptimo',
        enableEditing: false,
        muiTableHeadCellProps: {
          sx: getSubHeaderStyle(COLORS.greenDarkLight),
        },
        Cell: ({ cell, row }) => (
          <NumberCell 
            value={cell.getValue()} 
            prefix="$" 
            useLocaleString
            isEdited={editedRows.has(row.original.modeloPlaneacion)}
          />
        ),
      },
      {
        accessorKey: 'inventarioMedioEscogido',
        header: 'Inventario medio',
        enableEditing: false,
        muiTableHeadCellProps: {
          sx: getSubHeaderStyle(COLORS.greenDarkLight),
        },
        Cell: ({ cell, row }) => (
          <NumberCell 
            value={cell.getValue()} 
            useLocaleString
            isEdited={editedRows.has(row.original.modeloPlaneacion)}
          />
        ),
      },
    ],
  },
  {
    header: 'NS seleccionado',
    accessorKey: 'tipoRegistro',
    muiTableHeadCellProps: {
      sx: getSubHeaderStyle(COLORS.greenDark, 'white'),
    },
    Cell: ({ cell }) => (
      <Typography variant="body2">
        {cell.getValue()}
      </Typography>
    )
  }
] 